import * as React from 'react';
import styled from 'styled-components';
import { BUTTON_SIZES } from 'ui/button';
import { AddNew16 } from 'ui/icons/aurora/16px/AddNew16';
import { colors, spacing } from 'ui/theme';
import { LinkButton } from './LinkButton';

const StyledLinkAddButton = styled(LinkButton)`
  display: inline-flex;
  column-gap: ${spacing.half};
`;

export type LinkAddButtonProps = {
  children: React.ReactNode;
  /** the route to which pressing this component will link  */
  to: string;
  /** if the page being routed to is angular, this component will return an anchor element. if it is a react route, it will use a react-router Link component.  */
  isAngular?: boolean;
  /** An override to disable the button */
  isDisabled?: boolean;
  /** The size variant of the button */
  size?: BUTTON_SIZES;
};

export const LinkAddButton = ({
  children,
  to,
  isAngular,
  isDisabled,
  size = BUTTON_SIZES.MEDIUM,
  ...props
}: LinkAddButtonProps) => {
  return (
    <StyledLinkAddButton
      to={to}
      isAngular={isAngular}
      isDisabled={isDisabled}
      size={size}
      {...props}
    >
      <AddNew16 color={colors.white} />
      {children}
    </StyledLinkAddButton>
  );
};
